// https://vuex.vuejs.org/en/getters.html

export default {
  getWhiteLabel: (state) => state.whitelabel,
  getMainCurrency: (state) => state.whitelabel.currency || "USD",
  getSupportedCurrencies: (state) => {
    if(state.whitelabel.supported_currencies && state.whitelabel.supported_currencies.length !== 0) {
      return state.whitelabel.supported_currencies.map(currency => currency.name);
    }
    return [];
  },
  isLotteryModule: (state) => state.whitelabel.modules.find(item => item.module === "lottery"),
};
